import React from 'react';
import { Chip } from '@mui/material';

import { TREND_COLORS } from '../trendTheme';

type TrendScoreProps = {
  label: string;
  value: number;
  max?: number;
  size?: 'small' | 'medium';
};

function toneFor(ratio: number): { bg: string; fg: string } {
  if (ratio >= 0.7) return { bg: TREND_COLORS.navy, fg: '#fff' };
  if (ratio >= 0.4) return { bg: TREND_COLORS.goldLight, fg: TREND_COLORS.terracotta };
  return { bg: TREND_COLORS.softNavy, fg: TREND_COLORS.navy };
}

/**
 * Unified score badge so every surface (priority, evidence, confidence,
 * severity) shows numeric scores the same way: "<Label> <value>/<max>".
 */
export default function TrendScore({ label, value, max = 100, size = 'small' }: TrendScoreProps) {
  const safeMax = max > 0 ? max : 100;
  const ratio = Math.max(0, Math.min(1, value / safeMax));
  const tone = toneFor(ratio);
  return (
    <Chip
      size={size}
      label={`${label} ${Math.round(value)}/${safeMax}`}
      sx={{ bgcolor: tone.bg, color: tone.fg, fontWeight: 700, fontSize: '0.7rem' }}
    />
  );
}
